<template>
  <vs-card>
    <div slot="header">
      <h3>Análise Técnica</h3>
    </div>
    <div>
      <div class="grid lg:grid-cols-8 gap-2">
        <!-- Análise de vistoria Prévia -->
        <div class="col-span-2">
          <label class="vs-input--label">Análise de vistoria Prévia</label>
          <vs-switch
            v-model="formAnaliseTecnica.analiseVistoriaPrevia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Monta conforme análise -->
        <div class="col-span-2">
          <label class="vs-select--label">Monta conforme análise</label>
          <v-select
            :options="listMonta"
            name="Monta"
            id="Monta"
            v-model="formAnaliseTecnica.idMonta"
            label="label"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Evento Aprovado -->
        <div class="col-span-1">
          <label class="vs-input--label">Evento Aprovado</label>
          <vs-switch
            v-model="formAnaliseTecnica.eventoAprovado"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Perda Total -->
        <div class="col-span-1">
          <label class="vs-input--label">Perda Total</label>
          <vs-switch
            v-model="formAnaliseTecnica.perdaTotal"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Sindicância -->
        <div class="col-span-1">
          <label class="vs-input--label">Sindicância</label>
          <vs-switch
            v-model="formAnaliseTecnica.sindicancia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
        <!-- Perícia -->
        <div class="col-span-1">
          <label class="vs-input--label">Perícia</label>
          <vs-switch
            v-model="formAnaliseTecnica.pericia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
      </div>
      <!-- Resumo do Analista -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <span class="vs-input--label">Resumo do Analista</span>
          <vue-editor
            v-model="formAnaliseTecnica.resumoAnalista"
            :editor-toolbar="customToolbar"
          ></vue-editor>
        </div>
      </div>

      <HistoricoResumoAnalista
        :historicoResumoAnalista="historicoResumoAnalista"
      />

      <!-- Conclusão do Comitê -->
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <p>Conclusão do Comitê</p>
          <vue-editor
            v-model="formAnaliseTecnica.conclusaoComite"
            :editor-toolbar="customToolbar"
            class="w-full"
          ></vue-editor>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import vSelect from 'vue-select';
import { VueEditor } from 'vue2-editor';
import HistoricoResumoAnalista from '../../shared/components/HistoricoResumoAnalista.vue';
import customToolbar from '../../../../../components/editor/config';

export default {
  props: ['formData', 'dominios', 'historicoResumoAnalista'],
  watch: {
    formData(value) {
      if (!value.analiseTecnica) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - ANALISE TECNICA FORM');
        return;
      }

      this.formAnaliseTecnica = Object.assign(
        this.formAnaliseTecnica,
        value.analiseTecnica,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.analiseTecnica = this.formAnaliseTecnica;
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.analiseTecnica.resumoAnalista = '';
    },
  },
  components: {
    vSelect,
    VueEditor,
    HistoricoResumoAnalista,
  },
  data() {
    return {
      customToolbar,
      formAnaliseTecnica: {
        analiseVistoriaPrevia: false,
        eventoAprovado: false,
        perdaTotal: false,
        sindicancia: false,
        pericia: false,
        idMonta: null,
        resumoAnalista: null,
        conclusaoComite: null,
        avisoAssociadoTerceiroConincidem: null,
        terceiroInformacoesDiverventes: null,
        informacoesDiverventes: null,
      },
      listMonta: [],
    };
  },
  mounted() {
    if (!this.formData.analiseTecnica) {
      console.error('ERRO NO CONTRATO DO OBJETO - ANALISE TECNICA FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.analiseTecnica = this.formAnaliseTecnica;

    if (this.dominios) {
      this.listMonta = this.dominios.listMonta;
    }
  },
};
</script>
